import { getSenderIdentity } from '../helpers/messages';
export default [
    'WebClientService', 'ReceiverService', 'MessageService', '$filter',
    function (webClientService, receiverService, messageService, $filter) {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                conversation: '<',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.$onInit = function () {
                        this.isGroup = this.conversation.type === 'group';
                        this.isDistributionList = !this.isGroup && this.conversation.type === 'distributionList';
                        this.showVoipInfo = () => this.conversation.latestMessage.type === 'voipStatus';
                        this.getStatusIcon = () => {
                            if (this.showVoipInfo()) {
                                return 'phone_locked';
                            }
                            else if (this.isGroup) {
                                return 'group';
                            }
                            else if (this.isDistributionList) {
                                return 'forum';
                            }
                            else if (!this.conversation.latestMessage.isOutbox) {
                                return 'reply';
                            }
                            else {
                                const showStatusIcon = messageService.showStatusIcon(this.conversation.latestMessage, this.conversation.receiver);
                                return showStatusIcon ? $filter('messageStateIcon')(this.conversation.latestMessage) : null;
                            }
                        };
                        this.getContact = () => {
                            return webClientService.contacts.get(getSenderIdentity(this.conversation.latestMessage, webClientService.me.id));
                        };
                        const contact = this.getContact();
                        this.isTyping = () => false;
                        if (this.isGroup === false && this.isDistributionList === false && contact !== null) {
                            this.isTyping = () => webClientService.isTyping(contact);
                        }
                        this.isHidden = () => this.conversation.receiver.locked;
                        this.showIcon = () => {
                            const message = this.conversation.latestMessage;
                            return message.type !== 'text' && message.type !== 'status';
                        };
                        this.getDraft = () => webClientService.getDraft(this.conversation.receiver);
                        this.showDraft = () => {
                            if (receiverService.isConversationActive(this.conversation.receiver)) {
                                return false;
                            }
                            const draft = this.getDraft();
                            return draft !== undefined && draft !== null;
                        };
                    };
                }],
            templateUrl: 'directives/latest_message.html',
        };
    },
];
